module.exports = __webpack_public_path__ + "static/pubsub1-7f3256b8029d360d4a755dc3e4ffb902.png";